import { LoadState } from "../../constants/enums";

export interface IPhoneExtension {
  id: number;
  number: string;
  name: string;
  tech: string;
  [key: string]: any;
}

export const initialPhoneExtension: IPhoneExtension = {
  id: 0,
  number: "",
  name: "",
  tech: "",
};

export interface IPhoneDid {
  di_id: string;
  di_te_id: string;
  di_country: string;
  di_area: string;
  di_number: string;
  di_comment: string;
  di_recording: string;
  di_didprefix: string;
  di_fax: string;
  di_faxstationid: string;
  di_faxheaderinfo: string;
  di_faxprotocol: string;
  di_fax_email: string;
  di_fax_store: string;
  di_didnameprefix: string;
  di_unconditionalstatus: string;
  di_maxchannels: string;
  di_cnam: string;
  di_allowemergency: string;
  di_emergencynotes: string;
  di_ibid: string;
  di_emailrecording: string;
  di_admincomment: string;
  di_notifyunassigned: string;
  di_minemailrecording: string;
  di_dp_id: string;
  di_provider_info: string | null;
  di_provider_number: string | null;
  di_smsprotocol: string;
  di_smsfromfield: string;
  di_smstofield: string;
  di_smsbodyfield: string;
  di_sms_store: string;
  di_smsemail: string;
  di_branch: string;
  di_department: string;
  di_storeandforwardnumber: string;
  di_notifymaxchannels: string;
  di_faxprinturl: string;
  di_smsanswer: string;
  di_mmslinkfield: string;
  di_faxprinturlformat: string;
  di_mmslinkauthprovider: string;
  di_transcript: string;
  di_sms_imsi: string;
  di_fullprivacy: string;
  di_aisummary: string;
  di_aisentiment: string;
  di_extrafieldserver: string;
  di_fax_rp_id: string;
  id: number;
  name: string;
}

export interface IPhoneCdr {
  accountcode: string;
  ID: string;
  start: string;
  answer: string;
  end: string;
  clid: string;
  realsrc: string;
  firstdst: string;
  duration: string;
  billsec: string;
  disposition: string;
  cc_cost: string;
  dcontext: string;
  dstchannel: string;
  userfield: string;
  uniqueid: string;
  prevuniqueid: string;
  lastdst: string;
  wherelanded: string;
  src: string;
  dst: string;
  lastapp: string;
  srcCallID: string;
  linkedid: string;
  peeraccount: string | null;
  originateid: string;
  cc_country: string;
  cc_network: string;
  pincode: string;
  cc_buy: string;
}

export interface IPhoneQueue {
  qu_id: string;
  qu_te_id: string;
  qu_name: string;
  qu_hosted: string;
  qu_alwaysrecord: string;
  qu_timeout: string;
  qu_parameters: string;
  qu_ringinuse: string;
  qu_calltimeout: string;
  qu_id_text: string;
  qu_number: string;
  qu_callbackabandoned: string;
  qu_callbackmaxattempts: string;
  qu_ivr_id: string;
  qu_notifyabandoned: string;
  qu_notifyabandonedemail: string;
  qu_notifyabandonedstart: string;
  qu_agentname: string;
  qu_numcallers: string;
  qu_progress: string;
  qu_ringoffline: string;
  qu_pauseonend: string;
  qu_allowredirect: string;
  id: number;
  name: string;
}

export interface IPhoneBook {
  pb_id: string;
  pb_te_id: string;
  pb_name: string;
  pb_includeext: string;
  pb_includeshortnum: string;
  id: number;
  name: string;
}

export interface IPhoneSimpleCdr {
  sc_te_id: string;
  tenantcode: string;
  sc_start: string;
  sc_direction: string;
  sc_calleridnum: string;
  sc_calleridname: string;
  sc_dialednum: string;
  sc_disposition: string;
  sc_duration: string;
  sc_billsec: string;
  sc_uniqueid: string;
  sc_whoanswered: string;
}

export interface IPhoneCdrAiAnalysis {
  transcript: string | null;
  summary: string | null;
  sentiment: string | null;
}

export interface IPhoneIvr {
  iv_id: string;
  iv_te_id: string;
  iv_name: string;
  iv_me_id: string;
  iv_timeout: string;
  iv_loopontimeout: string;
  iv_looponwrongkeypress: string;
  iv_allowdisa: string;
  iv_allowfeatures: string;
  iv_digittimeout: string;
  iv_allowcustom: string;
  iv_maxloops: string;
  iv_loopplaymessageonce: string;
  iv_allowanyextension: string;
  iv_ivrtype: string;
  iv_language: string;
  iv_minsilence: string;
  iv_silencethreshold: string;
  id: number;
  name: string;
}

// Voicemail
export interface IPhoneVoicemail {
  uniqueid: string;
  te_id: string;
  context: string;
  mailbox: string;
  fullname: string;
  email: string;
  pager: string;
  attach: string;
  attachfmt: string | null;
  serveremail: string | null;
  language: string;
  tz: string;
  tzbytenant: string;
  deletevoicemail: string;
  saycid: string;
  sendvoicemail: string | null;
  review: string;
  tempgreetwarn: string | null;
  operator: string;
  envelope: string;
  sayduration: string | null;
  saydurationm: string | null;
  forcename: string | null;
  forcegreetings: string | null;
  callback: string | null;
  dialout: string | null;
  exitcontext: string;
  maxmsg: string;
  volgain: string | null;
  imapuser: string | null;
  stamp: string;
  welcomeoption: string;
  category: string;
  fromstring: string | null;
  minsecs: string;
  maxsecs: string;
  transcript_store: string;
  transcript_generate: string;
  autodeleteolder: string;
  voicemailbackup: string;
  summary_generate: string;
  id: number;
  name: string;
}

// Media Files
export interface IPhoneMediaFile {
  me_id: string;
  me_te_id: string;
  me_name: string;
  me_format: string;
  me_size: string;
  me_md5: string;
  me_moh: string;
  me_description: string;
  me_type: string;
  me_text: string;
  me_engine: string;
  me_language: string;
  me_voiceapiusername: string;
  me_volume: string;
  me_datetime: string;
  me_voiceapihost: string;
  id: number;
  name: string;
}

// Feature Codes
export interface IPhoneFeatureCode {
  fe_id: string;
  fe_te_id: string;
  fe_code: string;
  fe_comment: string;
  id: number;
  name: string;
}

// Click-to-Call
export interface IClickToCallPayload {
  source: string;
  dest: string;
  recording?: string;
  digitimeout?: number;
  autoanswer?: string;
  nofollow?: string;
  vars?: Record<string, any>;
  customer_id?: number | null;
  customer_policy_id?: number | null;
  lead_id?: string | null;
}

export interface IClickToCallResponse {
  message: string;
  callId?: string;
  call_ref?: string;
  [key: string]: any;
}

// Phonebook Entry
export interface IPhoneBookEntryDetail {
  pd_id: string;
  pd_te_id: string;
  pd_pe_id: string;
  pd_pi_id: string;
  pd_pi_value: string;
  pi_code: string;
  pi_name: string;
}

export interface IPhoneBookEntryRelatedPhonebook {
  pb_id: string;
  pb_te_id: string;
  pb_name: string;
  pb_includeext: string;
  pb_includeshortnum: string;
}

export interface IPhoneBookEntry {
  pe_id: string;
  pe_te_id: string;
  pe_pb_id: string;
  id: number;
  phonebook_id: number;
  object: string;
  values: {
    EMAIL: string;
    NAME: string;
    PHONE1: string;
    PHONE2: string;
    ROUTING: string;
  };
  details: IPhoneBookEntryDetail[];
  related: {
    phonebook: IPhoneBookEntryRelatedPhonebook;
  };
}

// Custom Destinations
export interface IPhoneCustomDestination {
  cu_id: string;
  cu_te_id: string;
  cu_name: string;
  cu_ct_id: string;
  cu_param1: string;
  cu_param2: string;
  cu_param3: string;
  cu_param4: string;
  cu_param5: string;
  cu_param6: string;
  cu_param7: string;
  cu_param8: string;
  cu_param9: string;
  cu_param10: string;
  cu_param11: string;
  cu_param12: string;
  cu_param13: string;
  cu_param14: string;
  cu_param15: string;
  cu_param16: string;
  cu_param17: string;
  cu_param18: string;
  cu_param19: string;
  cu_param20: string;
  id: number;
  name: string;
}

// Hunt Lists
export interface IPhoneHuntList {
  hu_id: string;
  hu_number: string | null;
  hu_name: string;
  hu_te_id: string;
  hu_type: string;
  hu_ringtime: string;
  hu_checkinuse: string;
  hu_checkoffline: string;
  hu_requestconfirm: string;
  hu_confirmmessage_id: string;
  hu_usemoh: string;
  hu_allowredirect: string;
  hu_allowadditionaldestinations: string;
  hu_allowfmfm: string;
  hu_dialtimeout: string;
  hu_fastdialing: string;
  hu_usecustomdetails: string;
  id: number;
  name: string;
}

// Conditions
export interface IPhoneCondition {
  co_id: string;
  co_te_id: string;
  co_name: string;
  co_type: string;
  co_timezone: string;
  co_param1: string;
  co_param2: string;
  co_param3: string;
  co_param4: string;
  co_param5: string;
  co_param6: string;
  co_param7: string;
  co_param8: string;
  co_param9: string;
  co_param10: string;
  co_param11: string;
  co_param12: string;
  co_param13: string;
  co_param14: string;
  co_param15: string;
  co_param16: string;
  co_param17: string;
  co_param18: string;
  co_param19: string;
  co_param20: string;
  co_param21: string;
  co_param22: string;
  id: number;
  name: string;
}

export interface IPhoneState {
  extensions: {
    list: IPhoneExtension[];
    loading: LoadState;
    extension: IPhoneExtension;
    extensionLoading: LoadState;
    saveLoading: boolean;
  };
  dids: {
    list: IPhoneDid[];
    loading: LoadState;
    saveLoading: boolean;
  };
  cdrs: {
    list: IPhoneCdr[];
    loading: LoadState;
  };
  simpleCdrs: {
    list: IPhoneSimpleCdr[];
    loading: LoadState;
  };
  queues: {
    list: IPhoneQueue[];
    loading: LoadState;
  };
  phoneBooks: {
    list: IPhoneBook[];
    loading: LoadState;
    saveLoading: boolean;
  };
  aiAnalysis: {
    data: IPhoneCdrAiAnalysis | null;
    loading: LoadState;
  };
  ivrs: {
    list: IPhoneIvr[];
    loading: LoadState;
    saveLoading: boolean;
  };
  voicemails: {
    list: IPhoneVoicemail[];
    loading: LoadState;
  };
  mediaFiles: {
    list: IPhoneMediaFile[];
    loading: LoadState;
  };
  featureCodes: {
    list: IPhoneFeatureCode[];
    loading: LoadState;
  };
  clickToCall: {
    loading: LoadState;
    error: string | null;
  };
  phoneBookEntries: {
    list: IPhoneBookEntry[];
    loading: LoadState;
  };
  customDestinations: {
    list: IPhoneCustomDestination[];
    loading: LoadState;
  };
  huntLists: {
    list: IPhoneHuntList[];
    loading: LoadState;
  };
  conditions: {
    list: IPhoneCondition[];
    loading: LoadState;
  };
  liveCall: {
    call_ref: string;
    extension: string;
    dest: string;
    started_ts: string;
  } | null;
  // The signed-in user's MirtaPBX extension (user_profile.phone_ext, surfaced
  // on latest_user.phone_ext). Null when the user has no extension assigned
  // on their profile — the Call button is disabled in that case.
  me: {
    phone_ext: string | null;
    loading: LoadState;
  };
}

export const initialPhoneState: IPhoneState = {
  extensions: {
    list: [],
    loading: LoadState.NotLoaded,
    extension: initialPhoneExtension,
    extensionLoading: LoadState.NotLoaded,
    saveLoading: false,
  },
  dids: {
    list: [],
    loading: LoadState.NotLoaded,
    saveLoading: false,
  },
  cdrs: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  simpleCdrs: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  queues: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  phoneBooks: {
    list: [],
    loading: LoadState.NotLoaded,
    saveLoading: false,
  },
  aiAnalysis: {
    data: null,
    loading: LoadState.NotLoaded,
  },
  ivrs: {
    list: [],
    loading: LoadState.NotLoaded,
    saveLoading: false,
  },
  voicemails: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  mediaFiles: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  featureCodes: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  clickToCall: {
    loading: LoadState.NotLoaded,
    error: null,
  },
  phoneBookEntries: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  customDestinations: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  huntLists: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  conditions: {
    list: [],
    loading: LoadState.NotLoaded,
  },
  liveCall: null,
  me: {
    phone_ext: null,
    loading: LoadState.NotLoaded,
  },
};
